import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class ImageErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
    color: PropTypes.string,
    icon: PropTypes.object,
    iconClassName: PropTypes.string,
    iconSize: PropTypes.string,
  };

  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? (
      <FontAwesomeIcon
        className={this.props.iconClassName}
        color={this.props.color}
        icon={this.props.icon}
        size={this.props.iconSize}
      />
    ) : (
      this.props.children
    );
  }
}
